export default "__VITE_ASSET__Ch8afD30__"